jQuery( document ).ready(function($) {
     $('.list-menu__item span').click(function(){
       $(this).closest('.list-menu__item').toggleClass('active_item');
    })
 

  $('.annouce-slider').flickity({
  contain: true,
  pageDots: false,
prevNextButtons: false,
    autoPlay: 5000 ,
    wrapAround: true
});
  var $backToTop = $(".back-to-top");
  $backToTop.hide();
  
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 100) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  });
  
  $backToTop.on('click', function(e) {
    $("html, body").animate({scrollTop: 0}, 500);
  });

  $('.product-grid-container').addClass('grid-view-section');
    // Toggle between grid and list view
    $('.grid-view').click(function() {
        $(this).addClass('active');
        $('.list-view').removeClass('active');
        $('.product-grid-container').removeClass('list-view-section1').addClass('grid-view-section');
        $('#product-grid').removeClass('grid--4-col-desktop grid--2-col-tablet-down').addClass('grid--2-col-desktop grid--1-col-tablet-down');
    });
  
    $('.list-view').click(function() {
        $(this).addClass('active');
        $('.grid-view').removeClass('active');
        $('.product-grid-container').removeClass('grid-view-section1').addClass('list-view-section1');
        $('#product-grid').removeClass('grid--2-col-desktop grid--1-col-tablet-down').addClass('grid--4-col-desktop grid--2-col-tablet-down');
      
    });
  });




document.addEventListener("DOMContentLoaded", function () {
  const stickyForm = document.querySelector("product-sticky-form");
  const footer = document.querySelector("footer");

  if (stickyForm && footer) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Footer is visible → hide sticky form
            stickyForm.style.display = "none";
          } else {
            // Footer is not visible → show sticky form
            stickyForm.style.display = "";
          }
        });
      },
      {
        root: null, // viewport
        threshold: 0, // trigger as soon as footer touches viewport
      }
    );

    observer.observe(footer);
  }
});

/* ===== healmeal Wunschliefertag (Cart-Drawer) =====
   Dropdown nur mit gültigen Liefertagen: Di–Fr, keine gesetzlichen Feiertage,
   frühestens heute + 5 Werktage, maximal 5 Termine. Der Kunde sieht ein lesbares
   Label ("Dienstag, 20. August 2026"), GESPEICHERT wird jedoch das ISO-Datum
   "2026-08-20" – so erwartet es ffn connect im Order-Tag. Wert landet sofort
   serverseitig als Cart-Attribut "Wunschliefertag wählen" via /cart/update.js. */
(function () {
  if (window.__hmWltInit) { return; }
  window.__hmWltInit = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var KEY = 'Wunschliefertag wählen';
  var ASAP = 'Schnellstmögliche Lieferung';
  var MONTHS = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  var WDAYS = ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'];
  var WDAYS_EN = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var LEAD = 5;    // Werktage Vorlauf (ohne Wochenende/Feiertage)
  var COUNT = 5;   // Anzahl wählbarer Liefertermine

  function addDays(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function fmt(d) { return d.getDate() + '. ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear(); }
  // Storefront-Sprache aus <html lang>. Alles was nicht mit "de" beginnt gilt als EN.
  function isEN() {
    var l = (document.documentElement.getAttribute('lang') || 'de').toLowerCase();
    return l.indexOf('de') !== 0;
  }
  // Nur die Beschriftung ist sprachabhaengig – der gespeicherte Wert bleibt ISO.
  function label(d) {
    if (isEN()) { return WDAYS_EN[d.getDay()] + ', ' + iso(d); }
    return WDAYS[d.getDay()] + ', ' + fmt(d);
  }
  // "2026-08-20" -> lesbares Label; alles andere unveraendert zurueck.
  function labelForValue(v) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(v)) { return v; }
    var d = new Date(Number(v.slice(0, 4)), Number(v.slice(5, 7)) - 1, Number(v.slice(8, 10)));
    if (isNaN(d.getTime())) { return v; }
    return label(d);
  }
  function hkey(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }

  // Bundeseinheitliche gesetzliche Feiertage (gelten überall in DE). Regionale Feiertage
  // (z. B. Fronleichnam, Reformationstag, Allerheiligen) bei Bedarf unten ergänzen.
  function easterSunday(Y) {
    var a = Y % 19, b = Math.floor(Y / 100), c = Y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451),
        mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Y, mo - 1, da);
  }
  var _holCache = {};
  function holidaysFor(Y) {
    if (_holCache[Y]) { return _holCache[Y]; }
    var s = {};
    function add(d) { s[hkey(d)] = true; }
    add(new Date(Y, 0, 1));   // Neujahr
    add(new Date(Y, 4, 1));   // Tag der Arbeit
    add(new Date(Y, 9, 3));   // Tag der Deutschen Einheit
    add(new Date(Y, 11, 25)); // 1. Weihnachtstag
    add(new Date(Y, 11, 26)); // 2. Weihnachtstag
    var e = easterSunday(Y);
    add(addDays(e, -2));      // Karfreitag
    add(addDays(e, 1));       // Ostermontag
    add(addDays(e, 39));      // Christi Himmelfahrt
    add(addDays(e, 50));      // Pfingstmontag
    _holCache[Y] = s;
    return s;
  }
  function isHoliday(d) { return !!holidaysFor(d.getFullYear())[hkey(d)]; }
  function isWorkday(d) { var wd = d.getDay(); return wd !== 0 && wd !== 6 && !isHoliday(d); }
  function isDeliveryDay(d) { var wd = d.getDay(); return wd >= 2 && wd <= 5 && !isHoliday(d); }

  function earliest() {
    var d = new Date(); d.setHours(0, 0, 0, 0);
    var added = 0;
    while (added < LEAD) { d = addDays(d, 1); if (isWorkday(d)) { added++; } }
    while (!isDeliveryDay(d)) { d = addDays(d, 1); }
    return d;
  }

  function buildOptions(sel, current) {
    sel.innerHTML = '';
    var o0 = document.createElement('option');
    // Wert bleibt immer der deutsche ASAP-String (ffn connect), Label kommt aus data-asap.
    var wrap = sel.closest ? sel.closest('.hm-wlt') : null;
    var asapLabel = (wrap && wrap.getAttribute('data-asap')) || '';
    o0.value = ASAP; o0.textContent = (asapLabel.trim() !== '') ? asapLabel : ASAP;
    sel.appendChild(o0);
    var d = earliest(), added = 0;
    while (added < COUNT) {
      if (isDeliveryDay(d)) {
        var val = iso(d);
        var o = document.createElement('option');
        o.value = val; o.textContent = label(d);
        sel.appendChild(o);
        added++;
      }
      d = addDays(d, 1);
    }
    if (current && current.trim() !== '' && current !== ASAP) {
      var found = false, i;
      for (i = 0; i < sel.options.length; i++) { if (sel.options[i].value === current) { sel.selectedIndex = i; found = true; break; } }
      if (!found) {
        var oc = document.createElement('option');
        oc.value = current; oc.textContent = labelForValue(current); oc.selected = true;
        sel.insertBefore(oc, sel.options[1] || null);
      }
    } else { sel.value = ASAP; }
  }

  function save(val, box) {
    var attrs = {}; attrs[KEY] = val;
    if (box) { box.classList.add('is-saving'); }
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    })
      .then(function (r) { return r.json(); })
      .then(function () { if (box) { box.setAttribute('data-current', val); } })
      .catch(function (err) { console.error('healmeal wlt save:', err); })
      .then(function () { if (box) { box.classList.remove('is-saving'); } });
  }

  function initBox(box) {
    if (!box || box.__hmWltReady) { return; }
    var sel = box.querySelector('.hm-wlt__select');
    if (!sel) { return; }
    box.__hmWltReady = true;
    var current = box.getAttribute('data-current') || '';
    buildOptions(sel, current);
    if (current.trim() === '') { save(ASAP, box); }
  }

  function scan() { document.querySelectorAll('.hm-wlt').forEach(initBox); }

  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('.hm-wlt__select') : null;
    if (!sel) { return; }
    save(sel.value || ASAP, sel.closest('.hm-wlt'));
  });

  function boot() {
    scan();
    var cd = document.querySelector('cart-drawer') || document.body;
    if (window.MutationObserver) { new MutationObserver(function () { scan(); }).observe(cd, { childList: true, subtree: true }); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
